import axios from 'axios';

/**
 * Extracts the error message from an error object.
 *
 * @example
 * const errorMessage = extractErrorMessage(error);
 *
 * @param error
 * @returns {string}
 */
export default function extractErrorMessage(error: unknown) {
  let errorMessage = '';

  // Basic use-case: cover our own community-functions API error messages.
  if (axios.isAxiosError(error)) {
    const detail = error?.response?.data?.detail || '';

    if (typeof detail === 'string') {
      errorMessage = detail;
    }
  }

  return errorMessage;
}
